/**
 * Controller for homepage, which includes key stats, plans, sites, tasks,
 * saved searches, and notifications
 * @author Christine Movius, Ryan Gladstone
 */

function HomepageController(
  $scope,
  $log,
  $q,
  $state,
  LoggedInUser,
  Task,
  companyService,
  filtersService,
  groupsService,
  localStorageService,
  notificationService,
  platformService,
  savedSearchService,
  siteService,
  featureFlag
) {
  const user = LoggedInUser;
  const storyUrlPath = 'planning.list';

  $scope.username = user.username;
  $scope.state = $state;

  $scope.tasksv2enabled = false;

  featureFlag.isEnabled('tasksv2').then((enabled) => {
    $scope.tasksv2enabled = enabled;
  });

  if (!localStorageService.get('websked.consideredDefaultView')) {
    /**
     * Because this is the default controller,
     * we need to determine if the user is on their first page load,
     * or if they came here 'on purpose'
     */
    localStorageService.set('websked.consideredDefaultView', true);

    // Fetch user details
    savedSearchService.getDefault().then((response) => {
      if (response && response !== {}) {
        const search = savedSearchService.processRawSearch(response);
        const filters = savedSearchService.processDates(search);
        const queryParams =
          filtersService.FilterSet.prototype.buildQueryParams(filters);
        $state.go(storyUrlPath, queryParams);
      }
    });
  }

  $scope.defaultFilters = filtersService.defaultFilters;

  // multisite plans functionality

  $scope.plansCollection = 'sections';

  $scope.missingData = {
    selectedWebsite: false,
    websites: false,
    websiteSections: false
  };

  this.initializePlansData = () => {
    $q.all([
      platformService.getAll(),
      companyService.get(),
      siteService.getWebsites()
    ]).then(
      (response) => {
        this.platforms = response[0];
        $scope.websiteHierarchies = response[1].siteServiceHierarchies || [];
        $scope.websites = response[2];

        if ($scope.selectedWebsite) {
          this.getWebsiteSections($scope.selectedWebsite._id);
          this.getWebsitePlatforms($scope.selectedWebsite._id);
        }
      },
      () => {
        $log.error('Error getting websites data from site service');
        $scope.missingData.websites = true;
      }
    );
  };

  $scope.selectedWebsite = siteService.getSelectedWebsite();
  if ($scope.selectedWebsite) {
    this.initializePlansData();
  } else {
    siteService.getDefaultWebsite().then((res) => {
      $scope.selectedWebsite = res;
      this.initializePlansData();
    });
  }

  this.getWebsitePlatforms = (id) => {
    $scope.websitePlatforms = platformService.getPlatformsByWebsiteId(id);
  };

  this.getWebsiteSections = (id) => {
    const website = $scope.websiteHierarchies.find(
      (websiteObj) => websiteObj.website === id
    );
    $scope.websiteHierarchy = website ? website.hierarchy : null;
    siteService.getNavigation(id, { hierarchy: $scope.websiteHierarchy }).then(
      (response) => {
        $scope.websiteSections = response.children;
      },
      () => {
        $log.error('Error getting website navigation data from site service');
        $scope.missingData.websiteSections = true;
      }
    );
  };

  $scope.onSelectWebsite = (id) => {
    const matchingSite = siteService.cache.websites.find(
      (site) => site._id === id
    );
    $scope.selectedWebsite = siteService.setSelectedWebsite(matchingSite);

    if ($scope.selectedWebsite) {
      this.getWebsiteSections(id);
      this.getWebsitePlatforms($scope.selectedWebsite._id);

      $scope.filterSet.getFilter('hierarchy').changeValue(id);
      $scope.filterSet.getFilter('websites').changeValue(id);
    } else {
      $scope.missingData.selectedWebsite = true;
    }
  };

  $scope.selectPlansCollection = (collection) => {
    $scope.plansCollection = collection;
  };

  // saved search functionality

  savedSearchService.getAll().then(
    (response) => {
      $scope.savedSearches = response.results;
    },
    (response) => {
      // handle rejected promise here
      $log.error('HomepageController getAll error: ', response);
    }
  );

  $scope.applySavedSearch = (search) => {
    const { params } = search;

    if (params.primaryWebsites && params.primaryWebsites.length > 0) {
      $scope.filterSet
        .getFilter('websites')
        .changeValue(params.primaryWebsites);
    }

    const savedSearchFilterSet = filtersService.createFilterSetFromUrl(search);
    const queryParams =
      savedSearchService.returnQueryParams(savedSearchFilterSet);
    $state.go(storyUrlPath, queryParams);
  };

  $scope.filterSet = filtersService.createFilterSetFromUrl();
  $scope.filterSet
    .getFilter('selectedPlan')
    .changeValue($scope.filterSet.getFilterValue('plan'));

  // notifications functionality

  notificationService.initialized.then(() => {
    notificationService.getAll('user', $scope.username, 0).then((data) => {
      if (data.length === 0) {
        $scope.showNotificationCard = true;
      } else {
        $scope.showNotificationCard = false;
      }
    });
  });

  // groups functionality

  groupsService.getGroups().then(
    (response) => {
      $scope.groups = response;
    },
    (response) => {
      // handle rejected promise here
      $log.error('HomepageController getGroups error: ', response);
    }
  );

  // tasks functionality

  const myAssignedTasksParams = {
    includeStories: true,
    size: 4,
    assignedUsers: user.username,
    sortBy: 'deadline',
    asc: false,
    status: [1, 2, 3]
  };

  Task.query(myAssignedTasksParams).then(
    (data) => {
      $scope.myAssignedTasks = data.results;
    },
    (response) => {
      $log.error('HomepageController myTasks error: ', response);
    }
  );

  const myCreatedTasksParams = {
    includeStories: true,
    size: 4,
    createdBy: user.username,
    sortBy: 'createdDate',
    asc: false,
    status: [1, 2, 3, 4]
  };

  Task.query(myCreatedTasksParams).then(
    (data) => {
      $scope.myCreatedTasks = data.results;
    },
    (response) => {
      $log.error('HomepageController myTasks error: ', response);
    }
  );
}

const arr = [
  '$scope',
  '$log',
  '$q',
  '$state',
  'LoggedInUser',
  'Task',
  'companyService',
  'filtersService',
  'groupsService',
  'localStorageService',
  'notificationService',
  'platformService',
  'savedSearchService',
  'siteService',
  'featureFlag',
  HomepageController
];

export default function (ngModule) {
  ngModule.controller('HomepageController', arr);
}
